import { render, staticRenderFns } from "./ContentAdditionalInformation.vue?vue&type=template&id=790eee9e"
import script from "./ContentAdditionalInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentAdditionalInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports